import React from 'react';
import PropTypes from 'prop-types';
import { gql, useQuery } from '@common/hooks';
import { Modal, Button } from 'antd';

import { LoadingState, PrimaryButton } from '@common/components';
import { StaffingRequestState } from 'works/legacy/components/staffing-request-state';

const GET_AFFECTED_RECORDS = gql`
  query StaffingRequestStateChangeInfo($staffingRequestId: ID!) {
    staffingRequest(id: $staffingRequestId) {
      id
      submittedStaffingRequestApplicationsCount
      inReviewStaffingRequestApplicationsCount
      offeredOffersStaffingRequestApplicationsCount
    }
  }
`;

export function StaffingRequestStateChangeModal({
  visible,
  onOk,
  onCancel,
  targetState,
  staffingRequestId,
}) {
  const { loading, error, data } = useQuery(GET_AFFECTED_RECORDS, {
    variables: { staffingRequestId },
  });

  return (
    <Modal
      open={visible}
      title="Confirm Status Change?"
      onCancel={onCancel}
      footer={[
        <PrimaryButton key="submit" onClick={onOk}>
          Confirm
        </PrimaryButton>,
        <Button key="back" onClick={onCancel}>
          Cancel
        </Button>,
      ]}
    >
      Updating this request to <StaffingRequestState state={targetState} /> will
      affect:
      {loading && !data && <LoadingState />}
      {error && <div>Unexpected error.</div>}
      {!loading && data && (
        <div>
          <strong>
            {(targetState === 'FILLED' || targetState === 'CANCELLED') && (
              <>
                <div>
                  {
                    data.staffingRequest
                      .submittedStaffingRequestApplicationsCount
                  }{' '}
                  Submitted candidates
                </div>
                <div>
                  {
                    data.staffingRequest
                      .inReviewStaffingRequestApplicationsCount
                  }{' '}
                  In Review candidates
                </div>
              </>
            )}
            <div>
              {
                data.staffingRequest
                  .offeredOffersStaffingRequestApplicationsCount
              }{' '}
              Offers
            </div>
          </strong>
        </div>
      )}
    </Modal>
  );
}

StaffingRequestStateChangeModal.propTypes = {
  staffingRequestId: PropTypes.string.isRequired,
  visible: PropTypes.bool,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  targetState: PropTypes.string.isRequired,
};
